<template>
    <div>
        <el-button type="primary" @click="open">打开运费费率表</el-button>
    </div>
</template>

<script>
    export default {
        methods:{
            open(){
                this.$router.push({
                    path:"/freightList"
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>